<template>
    <div class="modal fade center"
         id="EventConfigModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel"
         style="height:700px; position:absolute; top:320px"
         aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" style="width:500px">
                <div class="modal-header">
                    <h3 class="modal-title pull-left">Dados do evento:</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" style="text-align:center" 
                     >
                        <h4>
                            Horário em que será realizado:
                        </h4>
                        <input type="time" v-model="event_time"  class="form-control"/>
                        <hr>
                        <div>
                          <h4>
                            Unidade:
                          </h4>
                          <div class="wrapper">
                            <input type="radio" name="select2" id="option-3" :value=false checked v-model="selectBranches">
                            <input type="radio" name="select2" id="option-4" :value=true v-model="selectBranches">
                               <label for="option-3" class="option option-3">
                                 <div class="dot"></div>
                                  <span>Todas as Unidades</span>
                                  </label>
                               <label for="option-4" class="option option-4">
                                 <div class="dot"></div>
                                  <span>Unidades Individuais</span>
                               </label> 
                            </div>
                            <div v-if="selectBranches">
                                <br>
                                <h4>Selecione as Unidades:</h4>
                                <v-select 
                                :options="branches"
                                label="name"
                                multiple
                                v-model="selectedBranches"
                                ></v-select>
                            </div>
                        </div>
                        <hr>
                        <div>
                          <h4>
                            Área:
                          </h4>
                          <div class="wrapper">
                            <input type="radio" name="select" id="option-1" :value=false checked v-model="selectTeams">
                            <input type="radio" name="select" id="option-2" :value=true v-model="selectTeams">
                               <label for="option-1" class="option option-1">
                                 <div class="dot"></div>
                                  <span>Todas as Áreas</span>
                                  </label>
                               <label for="option-2" class="option option-2">
                                 <div class="dot"></div>
                                  <span>Áreas Individuais</span>
                               </label> 
                            </div>
                            <!-- Se o tema selecionado possui areas de aplicação as opções do select vão ser essas areas de aplicação  -->
                            <div v-if="selectTeams && selectedThemeTeams && selectedThemeTeams.length > 0">
                                <br>
                                <h4>Selecione as Áreas:</h4>
                                <v-select 
                                :options="selectedThemeTeams"
                                label="name"
                                multiple
                                v-model="selectedTeams"
                                ></v-select>
                            </div>
                            <!-- Se o tema selecionado não possui areas de aplicação as opções serão todas as areas -->
                            <div v-if="selectTeams && (!selectedThemeTeams || selectedThemeTeams.length < 1)">
                                <br>
                                <h4>Selecione as Áreas:</h4>
                                <v-select 
                                :options="teams"
                                label="name"
                                multiple
                                v-model="selectedTeams"
                                ></v-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" style="z-index:-1">
                    <button @click="Cancel" type="button" class="btn btn-danger pull-left" aria-label="Close">
                        Cancelar
                    </button>
                    <button @click="Apply" style="width:81px" type="button" class="btn btn-success" aria-label="Close">
                        Gerar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selectTeams: false,
                selectedTeams: [],
                teams: [],
                selectBranches: false,
                selectedBranches: [],
                branches: [],
                event_time: '',
            };
        },
        props: ["newEvent", "selectedThemeTeams"],
        methods: {
            Cancel(){
                this.$parent.getEvents();
                $("#EventConfigModal").modal("hide");
            },
            Apply() {
                if(!this.event_time) {
                    this.$message(
                        null,
                        "O horário é obrigatório.",
                        "error"
                    );
                    return;
                }

                if(this.selectTeams && (!this.selectedTeams || this.selectedTeams.length === 0)) {
                    this.$message(
                        null,
                        "Selecione pelo menos uma área.",
                        "error"
                    );
                    return;
                }

                if(this.selectBranches && (!this.selectedBranches || this.selectedBranches.length === 0)) {
                    this.$message(
                        null,
                        "Selecione pelo menos uma unidade.",
                        "error"
                    );
                    return;
                }

                this.$parent.saveEvent(
                    this.newEvent.id, 
                    this.newEvent.start.format(), 
                    5, 
                    this.event_time, 
                    this.selectedTeams, 
                    this.selectTeams,
                    this.selectedBranches, 
                    this.selectBranches
                );
                this.event_time = '';
                this.selectedTeams = [];
                this.selectedBranches = [];
                $("#EventConfigModal").modal("hide");
            },
            getTeams() {
                const self = this;
                const api =
                self.$store.state.api + "teams?paginated=false";

                self.$http
                  .get(api)
                  .then((response) => {
                    self.teams = response.data.data;
                  })
                  .catch((error) => {
                    self.$message(
                      null,
                      "Ocorreu um erro ao buscar as informações",
                      "error"
                    );
                  });
            },
            getBranches() {
                const self = this;
                const api =
                self.$store.state.api + "branches?paginated=false";

                self.$http
                  .get(api)
                  .then((response) => {
                    self.branches = response.data.data;
                  })
                  .catch((error) => {
                    self.$message(
                      null,
                      "Ocorreu um erro ao buscar as informações",
                      "error"
                    );
                  });
            },
        },
        mounted(){
            this.getTeams();
            this.getBranches();
        }
    }
</script>

<style scoped>
    .scroll-modal {
        max-height: 480px;
        overflow: overlay;
    }

    @media screen and (max-width: 767px) {
        .scroll-modal {
            max-height: unset;
        }
    }

    .center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
html,body{
  display: grid;
  height: 100%;
  place-items: center;
  background: #0069d9;
  font-family: 'Lato', sans-serif;
}
.wrapper{
  display: inline-flex;
  align-items: center;
  height:50px
}
.wrapper .option{
  background: #fff;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  padding: 0 10px;
  border: 2px solid lightgrey;
  transition: all 0.3s ease;
}
.wrapper .option .dot{
  height: 20px;
  width: 20px;
  background: #d9d9d9;
  border-radius: 50%;
  position: relative;
}
.wrapper .option .dot::before{
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  background: #0069d9;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"]{
  display: none;
}
.wrapper .option span{
  padding-left:5px;
  font-size: 15px;
  color: #808080;
}
#option-1:checked:checked ~ .option-1,
#option-2:checked:checked ~ .option-2,
#option-3:checked:checked ~ .option-3,
#option-4:checked:checked ~ .option-4{

  border-color: #0069d9;
  background: #0069d9;
}
#option-1:checked:checked ~ .option-1 .dot,
#option-2:checked:checked ~ .option-2 .dot,
#option-3:checked:checked ~ .option-3 .dot,
#option-4:checked:checked ~ .option-4 .dot{
  background: #fff;
}
#option-1:checked:checked ~ .option-1 .dot::before,
#option-2:checked:checked ~ .option-2 .dot::before,
#option-3:checked:checked ~ .option-3 .dot::before,
#option-4:checked:checked ~ .option-4 .dot::before{
  opacity: 1;
  transform: scale(1);
}
#option-1:checked:checked ~ .option-1 span,
#option-2:checked:checked ~ .option-2 span,
#option-3:checked:checked ~ .option-3 span,
#option-4:checked:checked ~ .option-4 span
{
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/CheckList/EventConfigModal.vue